module.exports = __webpack_public_path__ + "img/hospital-corridor-thumb.d29b114e.jpg";